export default __webpack_public_path__ + "static/media/signup_white.00e22be5.png";